export default __webpack_public_path__ + "static/media/KOD0020-min.c45e62e6.webp";